import React from 'react';
import Img from "../../images/services/dm/custom.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Digitize, Automate And Simplify With Exceptional Digital Marketplace Service</h2>
                        <p>Partnering with digital marketplaces means taking an ecommerce platform a step ahead. These
                            online platforms work as ready-made business architectures, providing all-in-one solutions
                            for multiple payment methods, tracking delivery, and improving supply chain processes.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;